(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[259],{

/***/ "0BFP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_frameworks_line_Line__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ybtA");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var SectionLine = function SectionLine(props) {
  return __jsx(_components_frameworks_line_Line__WEBPACK_IMPORTED_MODULE_1__["Line"], {
    props: props
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SectionLine);

/***/ })

}]);